import { getCurrencyFormatter } from "@redotech/money/util";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useMemo } from "react";
import type { OrderWithPickStatus } from "../db/collections";

export const CustomerTotals = memo(function CustomerTotals({
  orders,
  pending,
}: {
  orders: OrderWithPickStatus[];
  pending: boolean;
}) {
  const { totalSpent, totalOrders, currency } = useMemo(() => {
    if (!orders.length) {
      return { totalSpent: 0, totalOrders: 0, currency: "USD" };
    }

    const total = orders.reduce((sum, order) => {
      const orderTotal =
        order.shopify.total_price_usd || order.shopify.total_price;
      return sum + Number(orderTotal);
    }, 0);

    // Use the currency from the first order (all orders should be in same currency for a customer)
    const orderCurrency = orders[0]?.shopify.presentment_currency || "USD";

    return {
      totalSpent: total,
      totalOrders: orders.length,
      currency: orderCurrency,
    };
  }, [orders]);

  const formattedTotal = pending
    ? "-"
    : getCurrencyFormatter(currency).format(totalSpent);

  return (
    <Flex dir="column" gap="xs">
      <Flex justify="space-between">
        <Text fontSize="xs" fontWeight="medium" textColor="tertiary">
          Total spent
        </Text>
        <Text fontSize="xs" fontWeight="medium" textColor="primary">
          {formattedTotal}
        </Text>
      </Flex>
      <Flex justify="space-between">
        <Text fontSize="xs" fontWeight="medium" textColor="tertiary">
          Total orders
        </Text>
        <Text fontSize="xs" fontWeight="medium" textColor="primary">
          {pending ? "-" : totalOrders}
        </Text>
      </Flex>
      <Flex justify="space-between">
        <Text fontSize="xs" fontWeight="medium" textColor="tertiary">
          Total returns
        </Text>
        <Text fontSize="xs" fontWeight="medium" textColor="primary">
          -
        </Text>
      </Flex>
    </Flex>
  );
});
